<script lang="ts">
  import { Input } from "$lib/components/ui/input";
  import { Label } from "$lib/components/ui/label";
  import { t, locale } from "$lib/i18n";

  let {
    printRun = $bindable<number | null>(null),
    isReadonly = false,
    containerClass = "grid grid-cols-4 items-center gap-4",
    inputClass = "col-span-3",
    labelClass = "",
  }: { printRun: number | null; isReadonly?: boolean; containerClass?: string; inputClass?: string; labelClass?: string } = $props();

  function format(n: number | null): string {
    return n != null ? n.toLocaleString($locale) : '';
  }

  let displayValue = $state(format(printRun));
  let isEditing = $state(false);

  $effect(() => {
    if (!isEditing) {
      displayValue = format(printRun);
    }
  });
</script>

{#if !isReadonly || printRun !== null}
  <div class={containerClass}>
    <Label for="print_run" class={labelClass}>{$t('fields.printRun')}</Label>
    {#if isReadonly}
      <span class="{inputClass} text-sm">{format(printRun)}</span>
    {:else}
      <Input
        id="print_run"
        type="text"
        inputmode="numeric"
        class={inputClass}
        value={displayValue}
        onfocus={() => {
          isEditing = true;
          displayValue = printRun != null ? String(printRun) : '';
        }}
        oninput={(e) => {
          const el = e.target as HTMLInputElement;
          const digits = el.value.replace(/\D/g, '');
          el.value = digits;
          printRun = digits === '' ? null : Number(digits);
        }}
        onblur={() => {
          isEditing = false;
          displayValue = format(printRun);
        }}
      />
    {/if}
  </div>
{/if}
